interface MenuItem {
  id: string;
  icon: string;
  label: string;
}

export const getMenuItems = (menuItens: MenuItem[], enableViewTicket: boolean) => {
  if (!enableViewTicket) {
    return menuItens.filter(
      (item: MenuItem, index) => item.id !== 'ticket' && !(item.id === 'divider' && index === menuItens.length - 2),
    );
  }
  return menuItens;
};
